import { AxiosResponse } from "axios";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { ICurrentUser } from "../../../../@types/User";
import { ToastNotification } from "../../../../components/ToastNotification";
import useIsMobile from "../../../../hooks/useIsMobile";
import { useModal } from "../../../../hooks/useModal";
import { PageTitle } from "../../../../layout/components/PageTitle";
import { userService } from "../../../../services/userService";
import { SecurityModal } from "../SecurityModal";
import { SecurityContainer, EnabledButton } from "./SecuritySection.styles";

export function SecuritySection() {
  const { t } = useTranslation();

  const { openModal } = useModal();
  const [isMfaEnabled, setIsMfaEnabled] = useState(false);
  const [wasDisableSuccessful, setWasDisableSuccessful] = useState(false);
  const [wasEnableSuccessful, setWasEnableSuccessful] = useState(false);
  const [user, setUser] = useState<ICurrentUser>();
  const { widthView } = useIsMobile();

  useEffect(() => {
    userService.getCurrentUser().then((serverUser) => {
      setUser(serverUser);
      if (serverUser.mfa?.length) {
        setIsMfaEnabled(true);
      }
    });
  }, []);

  const disableMfa = () => {
    userService.disableUserMfa().then((response: AxiosResponse) => {
      if (response.status === 200) {
        setIsMfaEnabled(false);
        setWasDisableSuccessful(true);
        setTimeout(() => {
          setWasDisableSuccessful(false);
        }, 3500);
      }
    });
  };

  const handleEnableSuccess = () => {
    setWasEnableSuccessful(true);
    setTimeout(() => {
      setWasEnableSuccessful(false);
    }, 3500);
  };

  const handleModalWidth = (): string => {
    const x = widthView <= 768 ? "90vw" : "611px";
    return x;
  };

  const enableMfa = () => {
    openModal(
      <SecurityModal
        setIsMfaEnabled={setIsMfaEnabled}
        onClose={handleEnableSuccess}
        email={user?.email ?? ""}
      />,
      {
        width: handleModalWidth(),
        showCloseButton: false,
      }
    );
  };

  return (
    <>
      <br />
      <br />
      <PageTitle>{t("settings_security_title")}</PageTitle>

      <SecurityContainer>
        {t("settings_security_mfaLogin")}
        {isMfaEnabled ? (
          <EnabledButton onClick={disableMfa}>
            {t("settings_security_turnOffMfa")}
          </EnabledButton>
        ) : (
          <EnabledButton onClick={enableMfa}>
            {t("settings_security_turnOnMfa")}
          </EnabledButton>
        )}
      </SecurityContainer>
      {wasDisableSuccessful && (
        <ToastNotification
          message={t("settings_security_mfaDisabled")}
          type="success"
        />
      )}
      {wasEnableSuccessful && (
        <ToastNotification
          message={t("settings_security_mfaEnabled")}
          type="success"
        />
      )}
    </>
  );
}
